import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps2/ucl-quiz/api'
});
export const useUclQuizApi = () => ({
	captcha() {
		return httpClient.get('/captcha');
	},
	registration(model) {
		return httpClient.post('/registration', model);
	},
	startQuiz() {
		return httpClient.patch('/quiz-start');
	},
	submitQuiz(model) {
		return httpClient.post('/quiz-submit', model);
	}
});
